export type VariableKey =
  | 'pct_black_alone'
  | 'pct_black_combo'
  | 'black_alone'
  | 'pct_black_female_of_black'
  | 'black_median_age_female'
  | 'black_median_hh_income'
  | 'pct_black_youth_under_19_of_black'
  | 'pct_black_youth_0_24_of_black'
  | 'black_poverty_rate'
  | 'black_snap_rate'
  | 'black_lfpr'
  | 'black_unemployment_rate'
  | 'female_headed_hh_rate'
  | 'black_female_headed_hh_rate'
  | 'female_headed_family_poverty'
  | 'black_associate_or_higher_rate';

export type VariableFormat = 'percent' | 'count' | 'currency' | 'years';

export interface VariableMeta {
  key: VariableKey;
  format: VariableFormat;
  /** group id — matches i18n group keys */
  group: 'poblacion' | 'mujeres' | 'juventud' | 'economia' | 'hogar' | 'educacion';
}

export const DEFAULT_VARIABLE: VariableKey = 'pct_black_alone';

export const VARIABLES: VariableMeta[] = [
  { key: 'pct_black_alone', format: 'percent', group: 'poblacion' },
  { key: 'pct_black_combo', format: 'percent', group: 'poblacion' },
  { key: 'black_alone', format: 'count', group: 'poblacion' },

  { key: 'pct_black_female_of_black', format: 'percent', group: 'mujeres' },
  { key: 'black_median_age_female', format: 'years', group: 'mujeres' },
  { key: 'black_median_hh_income', format: 'currency', group: 'mujeres' },

  { key: 'pct_black_youth_under_19_of_black', format: 'percent', group: 'juventud' },
  { key: 'pct_black_youth_0_24_of_black', format: 'percent', group: 'juventud' },

  { key: 'black_poverty_rate', format: 'percent', group: 'economia' },
  { key: 'black_snap_rate', format: 'percent', group: 'economia' },
  { key: 'black_lfpr', format: 'percent', group: 'economia' },
  { key: 'black_unemployment_rate', format: 'percent', group: 'economia' },

  { key: 'black_female_headed_hh_rate', format: 'percent', group: 'hogar' },
  { key: 'female_headed_hh_rate', format: 'percent', group: 'hogar' },
  { key: 'female_headed_family_poverty', format: 'percent', group: 'hogar' },

  { key: 'black_associate_or_higher_rate', format: 'percent', group: 'educacion' },
];

export const VARIABLES_BY_KEY: Record<VariableKey, VariableMeta> = Object.fromEntries(
  VARIABLES.map((v) => [v.key, v]),
) as Record<VariableKey, VariableMeta>;

export const GROUP_ORDER: VariableMeta['group'][] = [
  'poblacion',
  'mujeres',
  'juventud',
  'economia',
  'hogar',
  'educacion',
];

export function isVariableKey(v: string): v is VariableKey {
  return v in VARIABLES_BY_KEY;
}
